export default __webpack_public_path__ + "static/media/rabbit27.d83e0ed5.gif";